import React, { useState } from "react";
import { submitUnsubscribeRequest } from "../../services/UnsubscribeApiService";
import "./Unsubscribe.css";

const Unsubscribe: React.FC = () => {
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState(""); // Separate state for "Other" reason
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [showModal, setShowModal] = useState(false); // Modal state

  const handleUnsubscribe = async () => {
    const finalReason = reason === "Other" ? otherReason : reason; // Use "Other" reason if selected
    if (!finalReason) {
      setMessage("Please select or provide a reason for unsubscribing.");
      return;
    }

    setIsLoading(true);
    try {
      const response = await submitUnsubscribeRequest({ reason: finalReason });
      if (response.success) {
        setMessage("Thank you for your feedback. You have been unsubscribed.");
      } else {
        setMessage("An error occurred. Please try again later.");
      }
    } catch (error) {
      setMessage("An error occurred. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleUnsubscribeClick = () => {
    setShowModal(true); // Show confirmation modal
  };

  const confirmUnsubscribe = () => {
    setShowModal(false); // Close modal
    handleUnsubscribe(); // Proceed with unsubscribe
  };

  return (
    <div className="unsubscribe-container">
      <h1>Unsubscribe</h1>
      <p>We're sorry to see you go. Please let us know why you're unsubscribing:</p>
      <div className="unsubscribe-reasons">
        <label>
          <input
            type="radio"
            name="reason"
            value="Not interested"
            checked={reason === "Not interested"}
            onChange={(e) => setReason(e.target.value)}
          />
          <span role="img" aria-label="Not interested">🙁</span> Not interested
        </label>
        <label>
          <input
            type="radio"
            name="reason"
            value="Too many emails"
            checked={reason === "Too many emails"}
            onChange={(e) => setReason(e.target.value)}
          />
          <span role="img" aria-label="Too many emails">📧</span> Too many emails
        </label>
        <label>
          <input
            type="radio"
            name="reason"
            value="Content not relevant"
            checked={reason === "Content not relevant"}
            onChange={(e) => setReason(e.target.value)}
          />
          <span role="img" aria-label="Content not relevant">❌</span> Content not relevant
        </label>
        <label>
          <input
            type="radio"
            name="reason"
            value="Other"
            checked={reason === "Other"}
            onChange={(e) => setReason(e.target.value)}
          />
          <span role="img" aria-label="Other">📝</span> Other
        </label>
        {reason === "Other" && (
          <textarea
            placeholder="Please specify your reason"
            value={otherReason} // Bind to "otherReason" state
            onChange={(e) => setOtherReason(e.target.value)} // Update "otherReason" state
            className="unsubscribe-textarea"
          />
        )}
      </div>
      <button onClick={handleUnsubscribeClick} disabled={isLoading}>
        {isLoading ? "Processing..." : "Unsubscribe"}
      </button>
      {message && <p className="message">{message}</p>}

      {/* Confirmation Modal */}
      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <p>Are you sure you want to unsubscribe?</p>
            <button onClick={confirmUnsubscribe}>Yes</button>
            <button onClick={() => setShowModal(false)}>No</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Unsubscribe;